import React from 'react';
import { ApiServerEntityIDType } from '@cp/utils/apiServer/types';
import { ModalLayout } from '@cp/ds/src/components/modalLayout';
import { ClientContacts } from 'src/widgets/client/some/contacts';
import { WithCommonModalProps } from 'src/app/shared/components/modals/model';

export interface AnotherClientContactsModalProps {
  clientId: ApiServerEntityIDType;
  onContactClick?: React.MouseEventHandler;
}
export const AnotherClientContactsModal: React.FC<WithCommonModalProps<AnotherClientContactsModalProps>> = ({ onClose, passedProps }) => {
  return (
    <ModalLayout containerSx={{ p: 0, maxWidth: { xs: 1, sm: 430 } }} onClose={onClose}>
      <ClientContacts onContactClick={passedProps.onContactClick} targetClientId={passedProps.clientId} />
    </ModalLayout>
  );
};
